import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { ApplicationShared } from 'core'
import { UnavailablePageWrapper, UnavailablePageTitle, UnavailablePageDescription, UnavailablePageButtons, BackButton, MainButton, UnavailablePageWrapperOuter } from './styles'
import { getLastApp, getLastPath } from 'routeHistory'
import { Book } from '@brg/api'
import { useAuth, useProfile } from '@brg/auth'
import { QueueButtons } from '../project/components/QueueButtons'

export const NotPurchased: React.FC = ({ book, bookPaymentData }: { book: Book, bookPaymentData: any }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const [showBack, setShowBack] = useState(false)
  const profile = useProfile()
  const auth = useAuth()

  useEffect(() => {
    let canGoBack = false;
    const currentApp = ApplicationShared.application;

    if (getLastPath() && getLastApp() === currentApp) {
      canGoBack = true;
    }

    if (!canGoBack && document.referrer) {
      try {
        const sameOrigin = new URL(document.referrer).origin === window.location.origin;
        const sameApp = getLastApp() === currentApp;
        console.log('📋 sameOrigin =', sameOrigin, 'sameApp =', sameApp);
        if (sameOrigin && sameApp) {
          canGoBack = true;
        }
      } catch (e) {
        console.warn(e);
      }
    }

    setShowBack(canGoBack);
  }, []);


  const handleGoBack = useCallback(() => {
    if (getLastPath() && getLastApp() === ApplicationShared.application) {
      history.replace(getLastPath())
    } else {
      history.goBack()
    }
  }, [history])

  const handlePurchase = useCallback(() => {
    if (!profile) {
      return auth.login()
    }
    bookPaymentData?.onBuy && bookPaymentData?.onBuy()
  }, [bookPaymentData, profile, auth])

  return (
    <UnavailablePageWrapperOuter>
      <UnavailablePageWrapper>
        <UnavailablePageTitle>{t('unavailable.title')}</UnavailablePageTitle>
        <UnavailablePageDescription>{t('not_purchased.project_subtitle')}</UnavailablePageDescription>
      </UnavailablePageWrapper>
      <UnavailablePageButtons>
        {/* {showBack && (
          <BackButton onClick={handleGoBack}>
            {t('unavailable.back')}
          </BackButton>
        )} */}
        <QueueButtons
          bookPaymentData={bookPaymentData}
          showTagsButton={false}
          goToBookBuyProcessing={() => {
            return bookPaymentData?.onBuy();
          }}
          book={book}
          cards={[]}
          showQueue={false}
          setShowQueue={() => {}}
        />
      </UnavailablePageButtons>
    </UnavailablePageWrapperOuter>
  )
}

export default NotPurchased
import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { ApplicationShared } from 'core'
import { UnavailablePageWrapper, UnavailablePageTitle, UnavailablePageDescription, UnavailablePageButtons, BackButton, MainButton, UnavailablePageWrapperOuter } from './styles'
import { getLastApp, getLastPath } from 'routeHistory'
import { Book } from '@brg/api'
import { useAuth, useProfile } from '@brg/auth'
import { QueueButtons } from '../project/components/QueueButtons'

export const NotPurchased: React.FC = ({ book, bookPaymentData }: { book: Book, bookPaymentData: any }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const [showBack, setShowBack] = useState(false)
  const profile = useProfile()
  const auth = useAuth()

  useEffect(() => {
    let canGoBack = false;
    const currentApp = ApplicationShared.application;

    if (getLastPath() && getLastApp() === currentApp) {
      canGoBack = true;
    }

    if (!canGoBack && document.referrer) {
      try {
        const sameOrigin = new URL(document.referrer).origin === window.location.origin;
        const sameApp = getLastApp() === currentApp;
        console.log('📋 sameOrigin =', sameOrigin, 'sameApp =', sameApp);
        if (sameOrigin && sameApp) {
          canGoBack = true;
        }
      } catch (e) {
        console.warn(e);
      }
    }

    setShowBack(canGoBack);
  }, []);


  const handleGoBack = useCallback(() => {
    if (getLastPath() && getLastApp() === ApplicationShared.application) {
      history.replace(getLastPath())
    } else {
      history.goBack()
    }
  }, [history])

  const handlePurchase = useCallback(() => {
    if (!profile) {
      return auth.login()
    }
    bookPaymentData?.onBuy && bookPaymentData?.onBuy()
  }, [bookPaymentData, profile, auth])

  return (
    <UnavailablePageWrapperOuter>
      <UnavailablePageWrapper>
        <UnavailablePageTitle>{t('unavailable.title')}</UnavailablePageTitle>
        <UnavailablePageDescription>{t('not_purchased.project_subtitle')}</UnavailablePageDescription>
      </UnavailablePageWrapper>
      <UnavailablePageButtons>
        {/* {showBack && (
          <BackButton onClick={handleGoBack}>
            {t('unavailable.back')}
          </BackButton>
        )} */}
        <QueueButtons
          bookPaymentData={bookPaymentData}
          showTagsButton={false}
          goToBookBuyProcessing={() => {
            return bookPaymentData?.onBuy();
          }}
          book={book}
          cards={[]}
          showQueue={false}
          setShowQueue={() => {}}
        />
      </UnavailablePageButtons>
    </UnavailablePageWrapperOuter>
  )
}

export default NotPurchased
